var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAfIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 55,
    viewBox: "0 0 35 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1315_365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5313 0H5.46769C4.01757 0 2.62684 0.557066 1.60145 1.54865C0.576058 2.54023 0 3.88511 0 5.28742V49.7116C0 51.1139 0.576058 52.4588 1.60145 53.4504C2.62684 54.4419 4.01757 54.999 5.46769 54.999H29.5313C30.9814 54.999 32.3721 54.4419 33.3975 53.4504C34.4229 52.4588 34.999 51.1139 34.999 49.7116V5.28742C34.999 3.88511 34.4229 2.54023 33.3975 1.54865C32.3721 0.557066 30.9814 0 29.5313 0ZM32.8126 49.7116C32.8126 50.5532 32.4669 51.3602 31.8515 51.9553C31.2362 52.5504 30.4015 52.8847 29.5313 52.8847H5.46769C4.59744 52.8847 3.76283 52.5504 3.14746 51.9553C2.5321 51.3602 2.1864 50.5532 2.1864 49.7116V5.28742C2.18667 4.44603 2.53249 3.63919 3.14783 3.04433C3.76316 2.44947 4.59761 2.1153 5.46769 2.1153H29.5313C30.4015 2.1153 31.2362 2.4496 31.8515 3.04468C32.4669 3.63975 32.8126 4.44684 32.8126 5.2884V49.7116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.37524 44.4226H30.6269V8.46155H4.37524V44.4226ZM6.56266 10.5765H28.4378V42.3076H6.56266V10.5765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3226 50.9245C18.4707 50.9245 19.4014 50.0245 19.4014 48.9143C19.4014 47.8041 18.4707 46.9041 17.3226 46.9041C16.1746 46.9041 15.2439 47.8041 15.2439 48.9143C15.2439 50.0245 16.1746 50.9245 17.3226 50.9245Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5588 38.7502C18.2577 38.7502 18.8242 38.2023 18.8242 37.5265C18.8242 36.8507 18.2577 36.3029 17.5588 36.3029C16.86 36.3029 16.2935 36.8507 16.2935 37.5265C16.2935 38.2023 16.86 38.7502 17.5588 38.7502Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3408 38.7502C14.0397 38.7502 14.6062 38.2023 14.6062 37.5265C14.6062 36.8507 14.0397 36.3029 13.3408 36.3029C12.642 36.3029 12.0754 36.8507 12.0754 37.5265C12.0754 38.2023 12.642 38.7502 13.3408 38.7502Z",
    stroke: "white",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3549 38.7502C22.0535 38.7502 22.6199 38.2023 22.6199 37.5265C22.6199 36.8507 22.0535 36.3029 21.3549 36.3029C20.6562 36.3029 20.0898 36.8507 20.0898 37.5265C20.0898 38.2023 20.6562 38.7502 21.3549 38.7502Z",
    stroke: "white",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1727 4.02039H12.4722V6.70055H22.1727V4.02039Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1315_365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfIcon2);
export default __webpack_public_path__ + "static/media/af-icon2.17f478a532d5c1a0685dc78d6058482c.svg";
export { ForwardRef as ReactComponent };